import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { EnginAffectation } from '@/types';

interface EnginAffectationState {
  list: EnginAffectation[];
  pageNum: number;
  totalPages: number;
}

const initialState: EnginAffectationState = { list: [], pageNum: 0, totalPages: 0 };

const enginAffectationSlice = createSlice({
  name: 'enginAffectation',
  initialState,
  reducers: {
    setEnginAffectations(
      state,
      action: PayloadAction<EnginAffectation[] | { data: EnginAffectation[]; pageNum: number; totalPages: number }>
    ) {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        state.list = payload ?? [];
        state.pageNum = 0;
        state.totalPages = 0;
      } else if (payload) {
        state.list = payload.data ?? [];
        state.pageNum = payload.pageNum ?? 0;
        state.totalPages = payload.totalPages ?? 0;
      }
    },
    addEnginAffectation(state, action: PayloadAction<EnginAffectation>) {
      state.list.push(action.payload);
    },
    removeEnginAffectation(state, action: PayloadAction<{ engine_id: number; chantier_id: number }>) {
      const { engine_id, chantier_id } = action.payload;
      state.list = state.list.filter(
        (a) => !(a.engine?.id === engine_id && a.chantier?.id === chantier_id)
      );
    },
    editEnginAffectation(state, action: PayloadAction<EnginAffectation>) {
      const i = state.list.findIndex((a) => a.id === action.payload.id);
      if (i !== -1) state.list[i] = action.payload;
    },
  },
});

export const { setEnginAffectations, addEnginAffectation, removeEnginAffectation, editEnginAffectation } =
  enginAffectationSlice.actions;
export default enginAffectationSlice.reducer;
